// extracted by mini-css-extract-plugin
module.exports = {"container":"az_V8","rightContainer":"az_W8","priceContainer":"az_X8","paypalSection":"az_Y8","firstDivider":"az_Z8"};